var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2943 12.3452C-0.764766 15.4018 -0.764766 20.3575 2.2943 23.4142L8.80277 29.9174C12.0318 33.1438 17.267 33.1438 20.4961 29.9174L27.0045 23.4142C30.0636 20.3575 30.0636 15.4018 27.0045 12.3452L23.8674 9.21062C22.9332 8.27718 21.4194 8.27718 20.4852 9.21062C19.55 10.1451 19.55 11.661 20.4852 12.5955L23.6196 15.7274C24.8093 16.9161 24.8093 18.8433 23.6196 20.032L17.1112 26.5352C15.7516 27.8937 13.5472 27.8937 12.1877 26.5352L5.6792 20.032C4.48956 18.8433 4.48956 16.9161 5.6792 15.7274L14.7195 6.68761C16.5475 4.85978 16.5469 1.896 14.7183 0.0688475C14.6803 0.0308151 14.621 0.0283528 14.583 0.0663851L8.47185 6.1726L2.2943 12.3452Z",
    fill: "#42CFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a9a120baa8e83ab121dc0639c80adcb2.svg";
export { ForwardRef as ReactComponent };